import classNames from "classnames/bind";
import UIIcon from "common/blocks/UIIcon";

import styles from "./EventSection.module.scss";

interface EventSectionProps {
    location: string;
    time: string;
}

const cx = classNames.bind(styles);

const EventSection = ({ location, time }: EventSectionProps) => {
    return (
        <div className={cx("wrapper")}>
            <div className={cx("row")}>
                <UIIcon icon="MapLocation" className={cx("icon")} />
                <span className={cx("content")}>{location}</span>
            </div>
            <div className={cx("row")}>
                <UIIcon icon="Clock" className={cx("icon")} />
                <span className={cx("content")}>{time}</span>
            </div>
        </div>
    );
};

export default EventSection;
